var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4459 6.82747C17.8257 5.00887 19.744 5 19.744 5C19.744 5 20.0293 6.7098 18.6586 8.35688C17.1949 10.1156 15.5313 9.82781 15.5313 9.82781C15.5313 9.82781 15.2189 8.44464 16.4459 6.82747ZM15.7068 11.0255C16.4167 11.0255 17.7341 10.0498 19.4489 10.0498C22.4006 10.0498 23.5618 12.1501 23.5618 12.1501C23.5618 12.1501 21.2907 13.3113 21.2907 16.1288C21.2907 19.3073 24.1199 20.4026 24.1199 20.4026C24.1199 20.4026 22.1422 25.9692 19.4708 25.9692C18.2439 25.9692 17.29 25.1423 15.9973 25.1423C14.6799 25.1423 13.3725 26 12.5211 26C10.0817 26.0001 7 20.7196 7 16.4751C7 12.299 9.60848 10.1083 12.0551 10.1083C13.6457 10.1083 14.8799 11.0255 15.7068 11.0255Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ce455f4644ede9cc7527621c85ab73bf.svg";
export { ForwardRef as ReactComponent };